export const FETCH_PROPERTIES = 'FETCH_PROPERTIES';
export const PROPERTY_DETAILS = 'PROPERTY_DETAILS';
export const SWITCH_VIEW = 'SWITCH_VIEW'

